// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__uugzf","overlay":"Popup_overlay__gFyYy","closeButton":"Popup_closeButton__P4SHB"};